<script setup lang="ts">
import { useAppearance } from '@shared/composables/useAppearance';

const { colorScheme, darkThemeSupported } = useAppearance();
</script>

<template>
    <div v-if="darkThemeSupported">
        <div class="kgr-verticalMenu__itemHeader appearance__header">
            {{ $t('Farbschema') }}
        </div>
        <select
            v-model="colorScheme"
            class="kgr-select"
            :aria-label="$t('Farbschema wählen')"
        >
            <option value="light">
                {{ $t('Hell') }}
            </option>
            <option value="dark">
                {{ $t('Dunkel (beta)') }}
            </option>
        </select>
    </div>
</template>

<style lang="scss" scoped>
.appearance__header {
    display: flex;
    align-items: center;
    gap: 6px;
}
</style>
